module.exports = __webpack_public_path__ + "img/Agency_Name.892aa58f.svg";